
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component
  export default class Breadcrumb extends Vue {
    @Prop({
      type: Array,
      default() {
        return []
      }
    })
    navList!: { name: string, to?: string }[];

    created() {
      console.log('当前路径:', this.$route);
    }
  }

